type Tag = {
  tag: 'wait' | 'beginplay' | 'fold' | 'goallin' | 'outplayer' | 'sitoutplayer' | 'disconnect' | 'observ' | 'outforever'
}

export type Wait = Tag & { tag: 'wait' }
export type BeginPlay = Tag & { tag: 'beginplay' }
export type Fold = Tag & { tag: 'fold' }
export type GoAllIn = Tag & { tag: 'goallin' }
export type OutPlayer = Tag & { tag: 'outplayer' }
export type SitOutPlayer = Tag & { tag: 'sitoutplayer' }
export type OutForever = Tag & { tag: 'outforever' }
export type Disconnect = Tag & { tag: 'disconnect' }
export type Observ = Tag & { tag: 'observ' }

export type PlayerAction =
  | Wait
  | BeginPlay
  | Fold
  | GoAllIn
  | OutPlayer
  | SitOutPlayer
  | OutForever
  | Disconnect
  | Observ

export class PlayerActions {
  public static Wait: Wait = <Wait>{
    tag: 'wait'
  }

  public static BeginPlay: BeginPlay = <BeginPlay>{
    tag: 'beginplay'
  }

  public static Fold: Fold = <Fold>{
    tag: 'fold'
  }

  public static GoAllIn: GoAllIn = <GoAllIn>{
    tag: 'goallin'
  }

  public static Out: OutPlayer = <OutPlayer>{
    tag: 'outplayer'
  }

  public static SitOut: SitOutPlayer = <SitOutPlayer>{
    tag: 'sitoutplayer'
  }

  public static OutForever: OutForever = <OutForever>{
    tag: 'outforever'
  }

  public static Disconnect: Disconnect = <Disconnect>{
    tag: 'disconnect'
  }

  public static Observ: Observ = <Observ>{
    tag: 'observ'
  }

  static isWait(a: PlayerAction): a is Wait {
    return a.tag === 'wait'
  }

  static isBeginPlay(a: PlayerAction): a is BeginPlay {
    return a.tag === 'beginplay'
  }

  static isFold(a: PlayerAction): a is Fold {
    return a.tag === 'fold'
  }

  static isGoAllIn(a: PlayerAction): a is GoAllIn {
    return a.tag === 'goallin'
  }

  static isOut(a: PlayerAction): a is OutPlayer {
    return a.tag === 'outplayer'
  }

  static isSitOut(a: PlayerAction): a is SitOutPlayer {
    return a.tag === 'sitoutplayer'
  }

  static isOutForever(a: PlayerAction): a is OutForever {
    return a.tag === 'outforever'
  }

  static isDisconnect(a: PlayerAction): a is Disconnect {
    return a.tag === 'disconnect'
  }

  static isObserv(a: PlayerAction): a is Observ {
    return a.tag === 'observ'
  }
}
